import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import type { MediaUsageType } from '../../media/media-types';
import { BaseEntity } from './base.entity';

/**
 * PD-16339 — where a media item is used. Rebuilt from the content every time
 * a website is saved or published, and whenever an email template, promo,
 * category or brand is saved; it answers "Used on …" and blocks deleting an
 * item in use.
 *
 * Not audited: the rows are derived from content that is itself audited, and
 * a rebuild on every save would flood the audit log.
 */
@Index('idx_media_usage_asset', ['fkMediaAssetId'])
@Index('idx_media_usage_entity', ['usageType', 'entityId'])
@Entity('media_usage', {}, { auditable: false })
export class MediaUsageEntity extends BaseEntity {
	@Column('int', { name: 'fk_media_asset__id', unsigned: true })
	public fkMediaAssetId!: number;

	@Column('varchar', { name: 'usageType', length: 32 })
	public usageType!: MediaUsageType;

	// The using record's id (a website id, a template id, …), as text so every kind fits.
	@Column('varchar', { name: 'entityId', length: 64 })
	public entityId!: string;

	// Where inside it: for a website, the content file and field path.
	@Column({
		type: 'varchar',
		name: 'location',
		length: 255,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public location!: string;

	// What a person reads in "Used on" (the page or template name), captured at save time.
	@Column({
		type: 'varchar',
		name: 'label',
		length: 255,
		nullable: true,
		charset: 'utf8mb4',
		collation: 'utf8mb4_0900_ai_ci',
	})
	public label!: string | null;
}
